"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _selectors = require("@otpusk/apisearch-toolbox/dist/queries/selectors");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _Button = _interopRequireWildcard(require("../../../ui/Button"));
var _constants = require("../../../Search/constants");
var _selectors2 = require("../../store/selectors");
var _actions = require("./store/actions");
var _reload = _interopRequireDefault(require("./reload.svg"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var ResultsMoreButton = function ResultsMoreButton(_ref) {
  var queryID = _ref.queryID;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)('RESULTS'),
    t = _useTranslation.t;
  var getPricesSelector = (0, _react.useMemo)(function () {
    return (0, _selectors2.createGetPricesSelector)(_constants.MAIN_QUERIES);
  }, []);
  var isProccessSelector = (0, _react.useMemo)(function () {
    return (0, _selectors2.createIsProccessSelector)(_constants.MAIN_QUERIES);
  }, []);
  var isProccess = (0, _reactRedux.useSelector)(isProccessSelector);
  var activePage = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors.getQueryParam)(state, {
      queryID: queryID,
      paramName: _fn.QUERY_PARAMS.PAGE
    });
  });
  var prices = (0, _reactRedux.useSelector)(getPricesSelector);
  var isSetPricesByActivePage = (0, _react.useMemo)(function () {
    return R.call(R.pipe(R.prop(R.dec(activePage)), R.when(Boolean, function (pricesByPage) {
      return !R.isEmpty(pricesByPage);
    }), Boolean), prices);
  }, [activePage, prices]);
  var isShowMoreButton = isProccess ? activePage > 1 : isSetPricesByActivePage;
  var handleClick = (0, _react.useCallback)(function () {
    return dispatch((0, _actions.getPricesByNextPage)(R.inc(activePage)));
  }, [activePage, dispatch]);
  return isShowMoreButton && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.root
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    icon: _reload.default,
    loading: isProccess,
    theme: _Button.THEMES.GRAY,
    onClick: !isProccess ? handleClick : undefined
  }, t('NEXT_PAGE_BUTTON')));
};
ResultsMoreButton.propTypes = {
  queryID: _propTypes.default.string.isRequired
};
var _default = exports.default = (0, _react.memo)(ResultsMoreButton);